import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./critical-error-indicator.module.scss";
import { tokens } from "../../../styles/tokens";

const CriticalError: React.FC = () => {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.icon}>
          <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="56" stroke={tokens.err} strokeWidth="3" fill={tokens.errBg} />
            <path
              d="M60 35v30"
              stroke={tokens.err}
              strokeWidth="6"
              strokeLinecap="round"
            />
            <circle cx="60" cy="80" r="4" fill={tokens.err} />
          </svg>
        </div>

        <h2 className={styles.title}>
          {t("criticalError.title", "Oops! An error occurred while loading the page.")}
        </h2>
        <p className={styles.subtitle}>
          {t("criticalError.patience", "If that didn't help, please wait while our developers fix everything!")}
        </p>

        <button
          type="button"
          className={styles.reloadButton}
          onClick={handleReload}
        >
          {t("error.reload", "Reload Page")}
        </button>
      </div>
    </div>
  );
};

export default CriticalError;
